/**
 * 格式化日期时间工具函数
 */

/**
 * 格式化完整日期时间
 * @param value ISO 时间字符串，如 "2026-01-15T12:27:03Z"
 * @returns 格式化后的时间字符串，如 "2025-09-15 14:30"
 */
export function formatFullDateTime(value?: string): string {
  if (!value) return '';
  
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return value;
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } catch (e) {
    return value;
  }
}

/**
 * 格式化相对时间（今天/昨天/具体日期）
 * @param value ISO 时间字符串，如 "2026-01-15T12:27:03Z"
 * @returns 格式化后的时间字符串，如 "今天 17:18"、"昨天 13:12"、"2025-09-10"
 */
export function formatRelativeTime(value?: string): string {
  if (!value) return '';
  
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return value; // 如果解析失败，返回原值
    }
    
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const timeStr = `${hours}:${minutes}`;
    
    if (targetDate.getTime() === today.getTime()) {
      return `今天 ${timeStr}`;
    } else if (targetDate.getTime() === yesterday.getTime()) {
      return `昨天 ${timeStr}`;
    } else {
      // 显示具体日期和时间
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day} ${timeStr}`;
    }
  } catch (e) {
    return value; // 如果解析失败，返回原值
  }
}

/**
 * 日历日期 YYYY-MM-DD（用于列表卡片等）
 */
export function formatCalendarDate(value?: string): string {
  if (!value) return '';
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch {
    return '';
  }
}
